/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CUPaymentProviderResponse { 
    id?: number;
    creditUnionId?: string | null;
    paymentProviderId?: string | null;
    paymentProviderName?: string | null;
    currency?: string | null;
    isActive?: string | null;
    isLastUsed?: boolean;
}

